<template>
  <div>
    <div class="breadcrumb">
      <ul>
        <li v-for="(bc,i) in post.breadcrumbs" :key="i" :class="{'linked': !!bc.link}">
          <router-link tag="li" :to="bc.link">
            <div v-if="i === post.breadcrumbs.length -1">
              <a style="text-decoration: none; color: black; font-weight: bold;">{{bc.name}}</a>
            </div>
            <a v-else style="text-decoration: none; color: black;">{{bc.name}}</a>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- POST -->
    <moment-style-1 :post_video="post" v-if="post.status != 'No tiene acceso'"/>
  </div>
</template>

<script>
import MomentStyle1 from "./MomentStyle1";
import { mapState } from "vuex";

export default {
  components: {
    MomentStyle1,
  },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("user", ["current_user"]),
  },
  mounted(){
    // Redirecciona a Home en caso que la encuesta se encuentre en estado "Borrador" o si no tiene acceso
    if (this.post.status == "Borrador" && !this.current_user.role.includes('admin') || this.post.status == "No tiene acceso") {
      this.$router.push({ name: "home" });
    }
  },
};
</script>

<style scoped>
ul {
  display: flex;
  justify-content: left;
  list-style-type: none;
}
ul > li {
  display: flex;
  float: left;
  width: auto;
  color: default;
  font-weight: bold;
  font-size: 1.2em;
  cursor: default;
  align-items: center;
}
ul > li:not(:last-child)::after {
  content: ">";
  float: right;
  font-size: 1.2em;
  margin: 0 0.5em;
  color: light-default;
  cursor: default;
}
.linked {
  cursor: pointer;
  font-size: 1.2em;
  font-weight: normal;
}
</style>
